import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import he from 'he';


const toContentLink = (url_link) => {
  if (!url_link) return '/';
  const idx = url_link.indexOf('/content');
  return idx !== -1 ? url_link.substring(idx) : url_link;
};

const TopStories = ({ newsSlickData, newsSlickError }) => {
  const [topStories, setTopStories] = useState(newsSlickData);
  const [error, setError] = useState(newsSlickError);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (newsSlickData) {
      setLoading(false);
      return;
    }

    setLoading(true);

    const fetchData = async () => {
      try {
        const res = await fetch('https://www.teluguone.com/news_api/newsHomeSliderJson');
        if (!res.ok) throw new Error('response Was Not Good');
        const d = await res.json();
        setTopStories(d.slidernews);
        setError(null);
        setLoading(false);
      } catch (err) {
        setError(err.message || 'Something went wrong');
        setTopStories(null);
        setLoading(false);
        console.log('Error:', err.message);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="top-stories-section">
        <h1 className="top-stories-heading notranslate" translate="no">తాజా వార్తలు  <Link to="/contents/latestnews-25.html" >మరిన్ని →</Link></h1>
        <div className="top-stories-skeleton" />
      </div>
    );
  }

  if (error || !Array.isArray(topStories) || topStories.length === 0) {
    return (
      <div className="top-stories-section">
        <h1 className="top-stories-heading notranslate" translate="no">తాజా వార్తలు  <Link to="/contents/latestnews-25.html" >మరిన్ని →</Link></h1>
        <div className="json-loading-error-div">
          <img src={`${import.meta.env.BASE_URL}assets/images/json_error.png`} alt="json_loading_error" />
        </div>
      </div>
    );
  }

  
  const hero = topStories[0];
  const sideStories = topStories.slice(1, 6);
  const bottomStories = topStories.slice(6, 10);

  return (
    <div className="top-stories-section">
      <h1 className="top-stories-heading notranslate" translate="no">తాజా వార్తలు  <Link to="/contents/latestnews-25.html" >మరిన్ని →</Link></h1>

      <div className="top-stories-grid"> 
        {hero && (
          <Link to={toContentLink(hero.url_link)} className="top-story-hero">
            <img
              className="top-story-hero-img"
              src={hero.stimg || `${import.meta.env.BASE_URL}assets/images/error_img.webp`}
              alt={he.decode(hero.title ||  "alt")}
              loading="eager"
              fetchpriority="high"
            />
            <h2 className='top-story-hero-title'>{hero.title ? he.decode(hero.title) : ''}</h2>
          </Link>
        )}

        {/* Side: two stacked thumbnail stories */}
        <div className="top-story-side">
          {sideStories.map((item, i) => (
            <Link key={item.url_link || i} to={toContentLink(item.url_link)} className="top-story-side-item">
              <img
                className="top-story-side-img"
                src={item.stimg || `${import.meta.env.BASE_URL}assets/images/error_img.webp`}
                alt={he.decode(item.title)}
                loading="lazy"
              />
              <h3 className="top-story-side-title">{he.decode(item.title)}</h3>
            </Link>
          ))}
        </div>
      </div>

      {/* Bottom row: four across */}
      {bottomStories.length > 0 && (
        <div className="top-stories-bottom-row">
          {bottomStories.map((item, i) => (
            <Link key={item.url_link || i} to={toContentLink(item.url_link)} className="top-story-bottom-item">
              <img
                className="top-story-bottom-img"
                src={item.stimg || `${import.meta.env.BASE_URL}assets/images/error_img.webp`}
                alt={he.decode(item.title)}
                loading="lazy"
              />
              <h3 className="top-story-bottom-title">{he.decode(item.title)}</h3>
              {item.smalldesc && (
                <p
                  className="top-story-bottom-desc"
                  dangerouslySetInnerHTML={{ __html: he.decode(item.smalldesc) }}
                />
              )}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default TopStories;
